/* eslint-disable no-unused-expressions */
import React, { Component } from "react";
import './FacilityBookTabs.css';
import { apiCaller } from "../../../services/apiCaller";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import GuidlinesFAQ from "../components/TabGuidlinesFAQ";
import FacilityInfo from "../components/TabFacilityInfo";
import moment from "moment";
import ReactLoading from "react-loading";
import swal from "sweetalert";
import Swal from "sweetalert2";

class FacilityBookTabs extends Component {

    constructor(props) {
        super(props);
        const defaultDate = new Date();
        this.state = {
            facilities: {},
            times: {},
            timeClicked: false,
            bookingDate: defaultDate.getDay() === 0 ? defaultDate.setDate(defaultDate.getDate() + 1) : defaultDate.getDay() === 6 ? defaultDate.setDate(defaultDate.getDate() + 2) : defaultDate,
            timeSlotLoading: false,
            bookedSlots: 0,
            quotaUsed: 0,
            totalPax: 0,
            invitedGuest: '',
            guestErrors: [],
            bookingNote: '',
            isLoading: false,
            user: JSON.parse(localStorage.getItem("userData")),
            plans: [],
            plansLoading: true,
            quotaMode: 'auto', // 'auto' | 'manual'
            manualAllocation: {} // { [client_plan_id]: hours_used }
        };
    }

    componentDidMount() {
        this.getTimeSlot();
        this.getBookingQuotas();
    }

    getBookingQuotas = async () => {
        try {
            const response = await apiCaller.get(`/getBookingQuotas?facility_id=${this.props.data.id}`);
            this.setState({
                plans: response.data.data,
                plansLoading: false
            });
        } catch (error) {
            this.setState({ plansLoading: false });
            console.error("Failed to load booking quotas", error);
        }
    }

    getTimeSlot = async (date) => {
        try {
            const response = await apiCaller.get(`/getTimeTable?facility_id=${this.props.data.id}&date=${date || moment(this.state.bookingDate).format("YYYY-MM-DD")}`);
            // Exclude the time slot with time 1800
            response.data = Object.fromEntries(
                Object.entries(response.data).filter(([key, value]) => this.props.data.location_id !== 113 ?value.time !== 1800 : value.time !== 2200)
            );
            this.setState({
                times: response.data,
                timeSlotLoading: false,
                bookedSlots: 0
            });
        } catch (error) {
            return Swal.fire({
                icon: 'error',
                title: "Date Unavailable",
                text: 'Please Select Another Day',
            });
        }
    }

    toggleBooking(i) {
        const { user, times } = this.state;
        let tempData = { ...times };
        // Special coworking plan logic
        if (user?.has_coworking && user?.cowork_plan_quota >= 10 && this.props.data.facility_type === 3) {
            
            const allSelected = Object.values(tempData).filter(slot => slot.bookable && slot.clicked).length === (Object.values(tempData).filter(slot => slot.bookable).length); 
            if (allSelected) {
                // Unselect all
                Object.keys(tempData).forEach(idx => {
                    if (tempData[idx].bookable) delete tempData[idx].clicked;
                });
                this.setState({
                    times: tempData,
                    bookedSlots: 0,
                    quotaUsed: 0,
                    timeClicked: false
                });
            } else {
                // Select up to 10 bookable slots
                let count = 0;
                Object.keys(tempData).forEach(idx => {
                    if (tempData[idx].bookable && count < 10) {
                        tempData[idx].clicked = true;
                        count++;
                    } else {
                        delete tempData[idx].clicked;
                    }
                });
                this.setState({
                    times: tempData,
                    bookedSlots: count,
                    quotaUsed: count,
                    timeClicked: true
                });
            }
            return;
        }
        if (!tempData[i].bookable) {
            return false;
        }
        if (tempData[i].clicked) {
            this.setState(prevState => ({
                bookedSlots: prevState.bookedSlots - 1,
                quotaUsed:prevState.bookedSlots - 1,
            }));
            delete tempData[i].clicked;
        } else {
            tempData[i].clicked = true;
            this.setState(prevState => ({
                timeClicked: true,
                bookedSlots: prevState.bookedSlots + 1,
                quotaUsed: prevState.bookedSlots + 1
            }));
        }
        return this.setState({
            times: tempData
        });
    }

    handleChange = date => {
        const dateParam = date || new Date();
        this.setState({
            bookingDate: dateParam,
            timeSlotLoading: true
        });
        return this.getTimeSlot(moment(dateParam).format("YYYY-MM-DD"));
    };

    displayTimeSlotCard() {
        const timeSlotArray = Object.entries(this.state.times);
        const now = new Date();
        return timeSlotArray.length < 1 ? (
            <div className="mt-5 col-12 text-center">
                <h4 style={{ color: "#888888" }}>Sorry but we are unavailable on your selected date.</h4>
            </div>
        ) : (
            timeSlotArray.map((v, i) => {
                const timeValue = v[1].time;
                let bookableDate = this.state.times[i].bookable;
                if (((now.getHours() * 100) + now.getMinutes()) >= timeValue && now >= this.state.bookingDate) {
                    bookableDate = false;
                }
                return (
                    <div key={i} className={`col-6 col-md-3 col-lg-3 col-xl-4 p-2 time-slot `}>
                        <div onClick={() => this.toggleBooking(i)} className={`card time-slot-card ${bookableDate? "bg-available" : "bg-booked"} ${this.state.times[i].clicked ? "bg-success" : ""}`}>
                            <div className="card-body text-center">
                                {`${(v[1].time).toString().slice(0, -2)}:00`}<span className="d-block d-sm-inline"> - </span> <span className="d-block d-sm-inline">{`${(v[1].time + 100).toString().slice(0, -2)}:00`}</span>
                                {!bookableDate && <span className="d-block font-size-sm mt-1" style={{ opacity: 0.8 }}>Booked</span>}
                            </div>
                        </div>
                    </div>
                );
            })
        );
    }

    handleInputChange = (field) => (e) => {
        if (field === 'totalPax') {
            const val = parseInt(e.target.value, 10);
            const maxPax = this.props.data.max_pax;
            this.setState({
                [field]: isNaN(val) || val > maxPax ? "maxPax" : val
            });
        } else if (field === 'invitedGuest') {
            const raw = e.target.value;
            this.setState({ invitedGuest: raw });
            this.validateGuestEmails(raw);
        } else {
            this.setState({
                [field]: e.target.value
            });
        }
    }

    validateGuestEmails = (raw) => {
        const trimmed = raw.replace(/ /g, '');
        if (!trimmed) {
            this.setState({ guestErrors: [] });
            return;
        }
        const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
        const emails = trimmed.split(",");
        const errors = [];
        emails.forEach((email, i) => {
            if (!email) {
                errors.push(`Entry ${i + 1}: empty email`);
            } else if (!emailRegex.test(email)) {
                errors.push(`"${email}" is not a valid email`);
            }
        });
        this.setState({ guestErrors: errors });
    }

    prepareBookingData = () => {
        const bookedTimes = Object.values(this.state.times).filter(v => v.clicked).map(v => v.time);
        const { allocation } = this.allocateQuota();
        return {
            facility_id: this.props.data.id,
            location_id: this.props.data.location_id,
            booking_date: moment(this.state.bookingDate).format("YYYY-MM-DD"),
            times: bookedTimes,
            total_pax: this.state.totalPax,
            guests: this.state.invitedGuest.replace(/ /g, '') || null,
            booking_note: this.state.bookingNote || null,
            deduction_rate: this.getDeductionRate(),
            quota_allocation: allocation.map(a => ({
                client_plan_id: a.client_plan_id,
                hours_used: a.hours_used
            }))
        };
    }

    sendBookingData = async () => {
        if(this.state.totalPax === "maxPax"){
            return { status: false, msg:`Maximum pax for this facility is ${this.props.data.max_pax} ` };
        }

        if(!this.state.totalPax || this.state.totalPax < 1){
            return { status: false, msg: 'Please enter total pax (minimum 1).' };
        }

        // Check quota allocation sufficient
        const { allocation, remaining } = this.allocateQuota();
        if (allocation.length === 0) {
            return { status: false, msg: 'Please select quota allocation.' };
        }
        if (remaining > 0) {
            return { status: false, msg: `Insufficient quota. Still need ${remaining} more quota. Please select additional plans.` };
        }
        
        const bookingData = this.prepareBookingData();

        // Validate guest emails if provided
        if(bookingData.guests && bookingData.guests.length > 0){
            if (this.state.guestErrors.length > 0) {
                return { status: false, msg: `Invalid guest email(s): ${this.state.guestErrors.join(', ')}` };
            }
        }

        try {
            await apiCaller.post("/storeBookingWithQuota", bookingData);
            return { status: true };
        } catch (err) {
            return { status: false, msg: err.response?.data?.message || 'Something went wrong. Please try again.' };
        }
    }

    submitBooking = async () => {
        this.setState({
            isLoading: true,
            timeSlotLoading: true
        });
        const { allocation } = this.allocateQuota();
        const totalAllocated = allocation.reduce((sum, a) => sum + a.hours_used, 0);
        const bookedTimes = Object.values(this.state.times).filter(v => v.clicked).map(v => v.time);
        const timeSlotLabels = bookedTimes.map(t => 
            `<span style="display:inline-block;background:#f0e6ec;color:#9a2b59;border-radius:4px;padding:2px 8px;margin:2px 4px 2px 0;font-size:12px;font-weight:600;">${String(t).slice(0, -2)}:00 - ${String(t + 100).slice(0, -2)}:00</span>`
        ).join('');

        const allocationRows = allocation.map(a =>
            `<tr><td style="padding:4px 8px;font-size:13px;">${a.product}</td><td style="padding:4px 8px;font-size:13px;text-align:right;font-weight:600;">${a.hours_used} quota</td></tr>`
        ).join('');

        const summaryHtml = `
            <div style="text-align:left;font-size:14px;line-height:1.7;">
                <div style="margin-bottom:12px;">
                    <div style="color:#888;font-size:12px;margin-bottom:2px;">Date</div>
                    <div style="font-weight:600;">${moment(this.state.bookingDate).format("dddd, DD MMM YYYY")}</div>
                </div>
                <div style="margin-bottom:12px;">
                    <div style="color:#888;font-size:12px;margin-bottom:4px;">Time (${bookedTimes.length} slot${bookedTimes.length > 1 ? 's' : ''})</div>
                    <div style="line-height:2;">${timeSlotLabels}</div>
                </div>
                <div style="margin-bottom:12px;">
                    <div style="color:#888;font-size:12px;margin-bottom:2px;">Pax</div>
                    <div style="font-weight:600;">${this.state.totalPax}</div>
                </div>
                ${this.state.invitedGuest ? `<div style="margin-bottom:12px;">
                    <div style="color:#888;font-size:12px;margin-bottom:2px;">Guests</div>
                    <div style="font-weight:600;">${this.state.invitedGuest.replace(/ /g, '').split(',').length} email(s)</div>
                </div>` : ''}
                <div style="background:#f8f4f6;border-radius:6px;padding:8px;margin-top:4px;">
                    <div style="font-size:12px;color:#888;margin-bottom:4px;font-weight:600;">QUOTA USAGE</div>
                    <table style="width:100%;border-collapse:collapse;">
                        ${allocationRows}
                        <tr style="border-top:1px solid #e3e3e3;"><td style="padding:4px 8px;font-size:13px;font-weight:700;">Total</td><td style="padding:4px 8px;font-size:13px;text-align:right;font-weight:700;color:#9a2b59;">${totalAllocated} quota</td></tr>
                    </table>
                </div>
            </div>
        `;

        const confirmBooking = await Swal.fire({
            title: "Confirm Booking",
            html: summaryHtml,
            icon: "info",
            input: 'checkbox',
            inputPlaceholder: 'I have read and agree with the guidelines',
            inputValue: 0,
            confirmButtonText: 'Confirm Booking',
            confirmButtonColor: '#9a2b59',
            showCancelButton: true,
            cancelButtonText: 'Cancel',
            cancelButtonColor: '#6c757d',
            inputValidator: (result) => !result && 'You need to agree with the guidelines'
        });

        if (confirmBooking.isConfirmed) {
            Swal.fire({
                title: 'Processing...',
                html: 'Please wait while we process your booking.',
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => { Swal.showLoading(); }
            });
            const res = await this.sendBookingData();
            Swal.close();
            this.setState({ isLoading: false, timeSlotLoading: false });
            if (res.status) {
                swal("Nice", "Thank you, see you there!", "success").then(() => document.location.reload());
            } else {
                swal("Error", res.msg, "error");
            }
        } else {
            Swal.fire({
                title: 'Cancelling...',
                html: 'Reverting your selection.',
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                timer: 800,
                didOpen: () => { Swal.showLoading(); }
            });
            await new Promise(resolve => setTimeout(resolve, 800));
            this.setState({ isLoading: false, timeSlotLoading: false });
        }
    }

    getWeekdays = date => {
        const day = date.getDay();
        if (this.state.user.client_id === 1019310) {
            return true;
        }
        return day !== 0 && day !== 6;
    };

    // ===== Plan quota selector =====
    getPlanQuota = (plan) => {
        return plan.quota_remaining || 0;
    }

    toggleQuotaMode = (mode) => {
        this.setState({ quotaMode: mode, manualAllocation: {} });
    }

    handleManualAllocation = (clientPlanId, value, max) => {
        const val = parseInt(value, 10);
        const hours = isNaN(val) ? 0 : Math.max(0, Math.min(val, max));
        this.setState(prevState => ({
            manualAllocation: { ...prevState.manualAllocation, [clientPlanId]: hours }
        }));
    }

    getManualMax = (clientPlanId) => {
        const { plans, manualAllocation } = this.state;
        const plan = plans.find(p => p.client_plan_id === clientPlanId);
        const quotaRemaining = plan ? (plan.quota_remaining || 0) : 0;
        const quotaNeeded = this.getQuotaNeeded();
        // Total sudah dialokasi ke plan lain
        const usedByOthers = Object.entries(manualAllocation)
            .filter(([id]) => parseInt(id, 10) !== clientPlanId)
            .reduce((sum, [, hrs]) => sum + (hrs || 0), 0);
        // Max = min(sisa kuota plan ini, sisa jam yg belum dialokasi)
        return Math.min(quotaRemaining, quotaNeeded - usedByOthers);
    }

    // Deduction rate: facility 2004 uses 2 quota/slot by default, 1 if pax < 10
    getDeductionRate = () => {
        if (this.props.data.id === 2004) {
            return this.state.totalPax && this.state.totalPax >= 10 ? 2 : 1;
        }
        return this.props.data.deduction_rates;
    }

    getQuotaNeeded = () => {
        return this.state.bookedSlots * this.getDeductionRate();
    }

    allocateQuota = () => {
        const { plans, quotaMode, manualAllocation } = this.state;
        const quotaNeeded = this.getQuotaNeeded();

        if (quotaMode === 'manual') {
            const allocation = [];
            let totalUsed = 0;
            for (const plan of plans) {
                const hours = manualAllocation[plan.client_plan_id] || 0;
                if (hours > 0) {
                    allocation.push({ client_plan_id: plan.client_plan_id, product: plan.product, hours_used: hours });
                    totalUsed += hours;
                }
            }
            return { allocation, remaining: quotaNeeded - totalUsed };
        }

        // Auto mode: pick available plans, smallest first
        const available = plans
            .filter(p => p.available && this.getPlanQuota(p) > 0)
            .map(p => ({ ...p, quotaForFacility: this.getPlanQuota(p) }))
            .sort((a, b) => a.quotaForFacility - b.quotaForFacility);

        let remaining = quotaNeeded;
        const allocation = [];
        for (const plan of available) {
            const take = Math.min(plan.quotaForFacility, remaining);
            if (take > 0) allocation.push({ client_plan_id: plan.client_plan_id, product: plan.product, hours_used: take });
            remaining -= take;
            if (remaining <= 0) break;
        }
        return { allocation, remaining };
    }

    displayPlanSelector() {
        const { plans, bookedSlots, plansLoading, quotaMode, manualAllocation } = this.state;
        const { allocation, remaining } = this.allocateQuota();

        if (plansLoading) {
            return (
                <div className="mb-3 text-center">
                    <ReactLoading type="bubbles" style={{ margin: "0 auto", fill: "#888", height: 50, width: 50 }} />
                </div>
            );
        }

        if (plans.length === 0) {
            return (
                <div className="mb-3">
                    <label className="d-block font-size-rg font-sb mb-0">USE QUOTA FROM</label>
                    <div className="alert alert-warning font-size-sm">No active plans with quota available for this facility.</div>
                </div>
            );
        }

        return (
            <div className="mb-3">
                <label className="d-block font-size-rg font-sb mb-0">USE QUOTA FROM</label>

                {/* Mode toggle */}
                <div className="quota-mode-toggle">
                    <button
                        type="button"
                        className={`quota-mode-btn ${quotaMode === 'auto' ? 'active' : ''}`}
                        onClick={() => this.toggleQuotaMode('auto')}
                    >
                        Auto
                    </button>
                    <button
                        type="button"
                        className={`quota-mode-btn ${quotaMode === 'manual' ? 'active' : ''}`}
                        onClick={() => this.toggleQuotaMode('manual')}
                    >
                        Custom
                    </button>
                </div>

                {quotaMode === 'auto' && (
                    <label className="d-block font-size-sm font-rg opacity-06 mb-2">
                        System will automatically allocate from the smallest sufficient plan first.
                    </label>
                )}
                {quotaMode === 'manual' && (
                    <label className="d-block font-size-sm font-rg opacity-06 mb-2">
                        Input quota to use from each plan. Total must equal {this.getQuotaNeeded()} quota.
                        {this.getDeductionRate() > 1 && <span className="d-block" style={{ color: '#9a2b59' }}>(Deduction rate: {this.getDeductionRate()}x per slot)</span>}
                    </label>
                )}

                {/* Plan list */}
                {plans.map(plan => {
                    const planQuota = this.getPlanQuota(plan);
                    const hasQuota = planQuota > 0 && plan.available;
                    const autoAlloc = allocation.find(a => a.client_plan_id === plan.client_plan_id);
                    const manualVal = manualAllocation[plan.client_plan_id] || 0;
                    const isActive = (quotaMode === 'auto' && autoAlloc) || (quotaMode === 'manual' && manualVal > 0);

                    return (
                        <div
                            key={plan.client_plan_id}
                            className={`plan-card-item ${isActive ? 'plan-active' : ''} ${!hasQuota ? 'plan-disabled' : ''}`}
                        >
                            <div className="flex-grow-1">
                                <div className="font-size-sm font-sb">{plan.product}</div>
                                <div style={{ fontSize: 11, color: '#999' }}>Exp: {plan.expired_at}</div>
                                <div className="font-size-sm mt-1">
                                    Available: <b style={{ color: hasQuota ? '#27ae60' : '#999' }}>{planQuota}</b> quota
                                    {quotaMode === 'auto' && autoAlloc && (
                                        <span className="ml-2" style={{ color: "#9a2b59", fontWeight: 600 }}>
                                            → {autoAlloc.hours_used} quota used
                                        </span>
                                    )}
                                </div>
                            </div>
                            {quotaMode === 'manual' && hasQuota && (
                                <div style={{ width: 80 }}>
                                    <input
                                        type="number"
                                        className="form-control form-control-sm text-center booking-input"
                                        min={0}
                                        max={this.getManualMax(plan.client_plan_id)}
                                        value={manualVal}
                                        onChange={(e) => this.handleManualAllocation(plan.client_plan_id, e.target.value, this.getManualMax(plan.client_plan_id))}
                                        placeholder="0"
                                    />
                                    <div style={{ fontSize: 10, textAlign: 'center', color: '#999', marginTop: 2 }}>max {this.getManualMax(plan.client_plan_id)}</div>
                                </div>
                            )}
                        </div>
                    );
                })}

                {/* Allocation summary */}
                {bookedSlots > 0 && (
                    <div className="allocation-summary">
                        {this.getDeductionRate() > 1 && (
                            <div className="mb-1"><b>Note:</b> {bookedSlots} slot x {this.getDeductionRate()} = {this.getQuotaNeeded()} quota needed</div>
                        )}
                        {allocation.length > 0 ? (
                            <>
                                <b>Allocation:</b>{" "}
                                {allocation.map((a, i) => (
                                    <span key={i}>
                                        {a.product} {a.hours_used} quota
                                        {i < allocation.length - 1 ? " + " : ""}
                                    </span>
                                ))}
                                {" = "}{this.getQuotaNeeded() - remaining} / {this.getQuotaNeeded()} quota.
                            </>
                        ) : (
                            <span>No quota allocated yet.</span>
                        )}
                        {remaining > 0 && (
                            <div className="allocation-error">
                                Insufficient! Need {remaining} more quota.
                                {quotaMode === 'manual' ? " Increase allocation on available plans." : " Not enough quota available."}
                            </div>
                        )}
                    </div>
                )}
            </div>
        );
    }

    render() {
        const facilityData = this.props.data;

        return (
            <>
                <div className="m-t-10">
                    {this.state.modalSuccess ? this.modalSuccessBooking() : ""}
                    <div>
                        <ul className="nav nav-tabs tab-line desktop-ui" id="myTab2" role="tablist">
                            <li className="nav-item px-0">
                                <a className="nav-link active text-center" id="home-tab2" data-toggle="tab" href="#line-home"
                                    role="tab" aria-controls="home" aria-selected="true">
                                    <span className="menu-icon mr-1">
                                        <i className="icon-placeholder mdi mdi-book-open "></i>
                                    </span>
                                    Booking</a>
                            </li>
                            <li className="nav-item px-0">
                                <a className="nav-link text-center" id="profile-tab2" data-toggle="tab" href="#line-profile"
                                    role="tab" aria-controls="profile" aria-selected="false">
                                    <span className="menu-icon mr-1">
                                        <i className="icon-placeholder mdi mdi-information "></i>
                                    </span>
                                    Facility Info</a>
                            </li>
                            <li className="nav-item px-0">
                                <a className="nav-link text-center" id="contact-tab3" data-toggle="tab" href="#line-contact"
                                    role="tab" aria-controls="contact" aria-selected="false">
                                    <span className="menu-icon mr-1">
                                        <i className="icon-placeholder mdi mdi-account-question "></i>
                                    </span>
                                    Guidelines & FAQ's</a>
                            </li>
                        </ul>

                        <ul className="nav nav-tabs tab-line text-center mobile-ui" id="myTab2" role="tablist">
                            <li className="nav-item col-4 px-0">
                                <a className="nav-link active" id="home-tab2" data-toggle="tab" href="#line-home"
                                    role="tab" aria-controls="home" aria-selected="true">
                                    <span className="menu-icon d-block lh-16">
                                        <i className="icon-placeholder mdi mdi-book-open "></i>
                                    </span>
                                    <span className="font-size-sm font-rg">Booking</span>
                                </a>
                            </li>
                            <li className="nav-item col-4 px-0">
                                <a className="nav-link" id="profile-tab2" data-toggle="tab" href="#line-profile"
                                    role="tab" aria-controls="profile" aria-selected="false">
                                    <span className="menu-icon d-block lh-16">
                                        <i className="icon-placeholder mdi mdi-information "></i>
                                    </span>
                                    <span className="font-size-sm font-rg">Info</span>
                                </a>
                            </li>
                            <li className="nav-item col-4 px-0">
                                <a className="nav-link" id="contact-tab3" data-toggle="tab" href="#line-contact"
                                    role="tab" aria-controls="contact" aria-selected="false">
                                    <span className="menu-icon d-block lh-16">
                                        <i className="icon-placeholder mdi mdi-account-question "></i>
                                    </span>
                                    <span className="font-size-sm font-rg">Guide</span>
                                </a>
                            </li>
                        </ul>
                        <div className="tab-content tab-container pt-5" id="myTabContent2">
                            <div className="tab-pane fade show active" id="line-home" role="tabpanel"
                                aria-labelledby="home-tab">

                                {/* Step 1: Date & Pax */}
                                <div className={`booking-section ${this.state.totalPax && this.state.totalPax >= 1 && this.state.totalPax !== "maxPax" ? 'completed-section' : 'active-section'}`}>
                                    <div className="booking-section-header">
                                        <div className="booking-step-number">1</div>
                                        <div>
                                            <div className="booking-section-title">Date & Participants</div>
                                            <div className="booking-section-subtitle">Choose your booking date and number of participants</div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6 mb-3 mb-md-0">
                                            <label className="d-block font-size-sm font-sb mb-1">Booking Date</label>
                                            <DatePicker
                                                className="form-control booking-input w-100"
                                                selected={this.state.bookingDate}
                                                onChange={(date) => this.handleChange(date)}
                                                dateFormat="yyyy-MM-dd"
                                                filterDate={(date) => this.getWeekdays(date)}
                                                minDate={new Date()}
                                                maxDate={(new Date()).setDate((new Date()).getDate() + 90)}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="d-block font-size-sm font-sb mb-1">
                                                Total Pax <span style={{ color: '#c0392b' }}>*</span>
                                            </label>
                                            <input
                                                className="w-100 form-control booking-input"
                                                value={this.state.totalPax || ''}
                                                onChange={this.handleInputChange('totalPax')}
                                                placeholder="Enter number of participants"
                                                type="number"
                                                min="1"
                                            />
                                            {this.state.totalPax === "maxPax" && (
                                                <small className="text-danger d-block mt-1">Maximum pax for this facility is {this.props.data.max_pax}</small>
                                            )}
                                            {this.props.data.id === 2004 && this.state.totalPax > 0 && this.state.totalPax !== "maxPax" && (
                                                <small className="text-muted d-block mt-1">
                                                    Quota deduction: <b>{this.getDeductionRate()}x</b> per slot {this.state.totalPax < 10 ? '(pax < 10)' : '(pax >= 10)'}
                                                </small>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {/* Step 2: Time Selection */}
                                <div className={`booking-section ${this.state.bookedSlots > 0 ? 'completed-section' : (this.state.totalPax && this.state.totalPax >= 1 && this.state.totalPax !== "maxPax") ? 'active-section' : ''}`}>
                                    <div className="booking-section-header">
                                        <div className="booking-step-number">2</div>
                                        <div>
                                            <div className="booking-section-title">Select Time</div>
                                            <div className="booking-section-subtitle">Pick the most suitable time slots for your booking</div>
                                        </div>
                                    </div>

                                    {!this.state.totalPax || this.state.totalPax < 1 || this.state.totalPax === "maxPax" ? (
                                        <div className="text-center py-3" style={{ color: '#999' }}>
                                            <i className="mdi mdi-clock-outline" style={{ fontSize: 32, opacity: 0.4 }}></i>
                                            <p className="font-size-sm mt-2 mb-0">Please fill in Total Pax in Step 1 first</p>
                                        </div>
                                    ) : (
                                        <>
                                            {moment(this.state.bookingDate).isBefore(moment("2025-09-08")) && (
                                                <div className="alert alert-warning font-size-sm py-2">
                                                    Due to current conditions, the available time is adjusted.
                                                </div>
                                            )}
                                            <div className="row m-0">
                                                {
                                                    this.state.timeSlotLoading ?
                                                        <ReactLoading type="bubbles" style={{
                                                            margin: "0 auto",
                                                            fill: "rgb(136, 136, 136)",
                                                            height: 69,
                                                            width: 69
                                                        }} /> :
                                                        this.displayTimeSlotCard()
                                                }
                                            </div>
                                            {this.state.bookedSlots > 0 && (
                                                <div className="total-hours-badge">
                                                    Selected: <b>{this.state.bookedSlots}</b> hour{this.state.bookedSlots > 1 ? 's' : ''}
                                                    {this.getDeductionRate() > 1 && <span className="ml-2" style={{ fontSize: 11, color: '#888' }}>({this.getQuotaNeeded()} quota)</span>}
                                                    {this.state.user.has_coworking && this.props.data.facility_type === 3 ? <span className="ml-2" style={{ fontSize: 11 }}>(Coworking Day Plan)</span> : ""}
                                                </div>
                                            )}
                                        </>
                                    )}
                                </div>

                                {/* Step 3: Quota Allocation */}
                                <div className={`booking-section ${this.state.bookedSlots > 0 ? 'active-section' : ''}`}>
                                    <div className="booking-section-header">
                                        <div className="booking-step-number">3</div>
                                        <div>
                                            <div className="booking-section-title">Quota Allocation</div>
                                            <div className="booking-section-subtitle">Choose which plan(s) to use for this booking</div>
                                        </div>
                                    </div>
                                    {this.displayPlanSelector()}
                                </div>

                                {/* Step 4: Additional Info */}
                                <div className={`booking-section ${this.state.bookedSlots > 0 ? 'active-section' : ''}`}>
                                    <div className="booking-section-header">
                                        <div className="booking-step-number">4</div>
                                        <div>
                                            <div className="booking-section-title">Additional Details</div>
                                            <div className="booking-section-subtitle">Optional notes and guest invitations</div>
                                        </div>
                                    </div>
                                    <div className="mb-3">
                                        <label className="d-block font-size-sm font-sb mb-1">Booking Note</label>
                                        <textarea className="w-100 form-control booking-input" onChange={this.handleInputChange('bookingNote')} placeholder="e.g. Weekly Report Meeting Agenda" rows="2"></textarea>
                                    </div>
                                    <div>
                                        <label className="d-block font-size-sm font-sb mb-1">Invite Guests via Email</label>
                                        <small className="d-block text-muted mb-2">Separate multiple emails with comma, no spaces</small>
                                        <textarea
                                            className={`w-100 form-control booking-input ${this.state.guestErrors.length > 0 ? 'is-invalid' : this.state.invitedGuest ? 'is-valid' : ''}`}
                                            onChange={this.handleInputChange('invitedGuest')}
                                            placeholder="john@email.com,alex@gmail.com"
                                            rows="2"
                                        ></textarea>
                                        {this.state.guestErrors.length > 0 && (
                                            <div className="invalid-feedback d-block mt-1">
                                                {this.state.guestErrors.map((err, i) => <div key={i}>{err}</div>)}
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {/* Submit */}
                                <div className="mt-3">
                                    <button
                                        onClick={() => this.submitBooking()}
                                        className={`btn-book-now ${this.state.bookedSlots < 1 ? "d-none" : "d-block"}`}
                                        disabled={this.state.isLoading}
                                    >
                                        {this.state.isLoading
                                            ? <div className="spinner-border spinner-border-sm text-light" role="status"><span className="sr-only">Loading...</span></div>
                                            : 'Confirm Booking'
                                        }
                                    </button>
                                </div>
                            </div>
                            <FacilityInfo data={facilityData} />
                            <GuidlinesFAQ />
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default FacilityBookTabs;

